/* eslint-disable react/no-multi-comp */
import React from 'react';
import styled from 'styled-components';
import {labels} from '../../../../util/utils';
import {getSectionRelatedObjectsHeaders, getConfigurationForEntity} from '../Bodies/BodyTypes/BodySpecial/config';
import EllipsesControl from '../../EllipsesControl/EllipsesControl';
import {entities} from '../../../../util/uiconstants';
import Utility from '../../../../util/utilityfunctions';

const SectionRelatedObjectItem = (props) => {
	const {sectionRelatedObject, isSnapshotView, documentEntityId} = props;

	let headers = <></>;
	let docEntityId = documentEntityId === entities.Engagement ? entities.Risk : documentEntityId;
	// Get section related objects header configuration
	const headersList = getSectionRelatedObjectsHeaders(docEntityId, isSnapshotView);
	const headerCount = headersList?.length; // Added undefined check here to avoid UI blowing up..

	headers = headersList?.map((header, index) => {
		return (
			<section
				className={`header-${index === 0 ? 'entity-name' : 'entity-data'}
							${headerCount === 2 ? 'single-column' : ''}
							${headerCount === 3 ? 'three-column' : ''}
							${headerCount === 4 ? 'four-column' : ''}`}
			>
				<EllipsesControl
					content={header.label}
					tooltip={header.label}
					noOfLines={2}
					// width={index === 3 ? (window.innerWidth * WIDTH_9) / 100 : (window.innerWidth * WIDTH_50) / 100}
				/>
			</section>
		);
	});

	return (
		<SectionRelatedObjectWrapper className="SectionRelatedObjectWrapper">
			<section className="header-container">{headers}</section>
			<section className={`body-container customScrollbar ${headerCount === 2 ? 'sectionObjectRisk' : ''}`}>
				{sectionRelatedObject && sectionRelatedObject.length > 0 ? (
					sectionRelatedObject.sort(Utility.sortByMultipleKey('entityName')).map((object) => {
						return getConfigurationForEntity(object.entityId).render(object, {
							isTopLevel: true,
							sectionId: object.formSectionId,
							isSnapshotView: isSnapshotView
						});
					})
				) : (
					<section className="entity-content placeholder-text">
						<EllipsesControl
							content={labels.formsNoRelatedObjects}
							tooltip={labels.formsNoRelatedObjects}
							noOfLines={1}
						/>
					</section>
				)}
			</section>
		</SectionRelatedObjectWrapper>
	);
};

const SectionRelatedObjectWrapper = styled.section`
	padding: var(--px-10);

	.special-body-title {
		font-weight: 500;
		padding: 0 0 var(--px-10) 0;
	}
	.header-container {
		display: flex;
		font-weight: normal;
		color: var(--neutrals-900);
		background-color: var(--neutrals-200);
		border: var(--px-1) solid var(--neutrals-300);
		padding: var(--px-10);
		font-size: var(--px-14);
		.header-entity-name {
			width: 81.5%;
			display: inline-flex;
			padding-right: var(--px-10);
			line-height: var(--px-18);
			&.single-column {
				width: calc(100% - var(--px-180));
			}
			&.four-column {
				width: 54.5%;
			}
		}
		.header-entity-data {
			width: 21.5%;
			line-height: var(--px-18);
			padding-right: var(--px-10);
			padding-left: 0;
			@media only screen and(max-width: 1280px) {
				padding-left: var(--px-3);
			}
			&:last-child {
				justify-content: center;
				display: inline-flex;
			}
			&.single-column {
				width: 16%;
			}
			&.four-column {
				width: 15%;
				padding-left: var(--px-10);
			}
		}
	}
	.placeholder-text {
		font-size: var(--px-14);
		font-weight: 300;
		padding: var(--px-16) var(--px-12);
		min-height: var(--px-100);
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		.ellipses {
			justify-content: center;
		}
	}
	.body-container {
		border: var(--px-1) solid var(--neutrals-300);
		border-top: 0;
		background: var(--neutrals-00white);
		padding: 0 var(--px-10);
		width: 100%;
		max-height: var(--px-300);
		.entity-content {
			display: flex;
			font-size: var(--px-14);
			font-weight: 300;
			.entityContentText {
				display: flex;
				font-size: var(--px-14);
				font-weight: normal;
				width: calc(100% - var(--px-100));
				align-items: center;
				color: var(--neutrals-900);
				&.noRelatedObjectsFound {
					padding-left: var(--px-15);
					font-weight: 100;
				}
			}
			&.placeholder-text {
				font-size: var(--px-14);
				font-weight: 300;
				padding: var(--px-16) var(--px-12);
				min-height: var(--px-100);
				width: 100%;
				display: flex;
				justify-content: center;
				align-items: center;
				.ellipses {
					justify-content: center;
				}
			}
			.motif-tree-trigger:hover:not(:disabled) {
				text-decoration: none;
			}
			&.entity-content-level-1 {
				border-bottom: var(--px-1) solid var(--neutrals-300);
				padding: var(--px-10) 0;
				position: relative;
				&:last-child {
					border: 0;
				}
				.motif-tree-content {
					max-height: unset;
				}
				.motif-tree-trigger {
					.FourthCol {
						width: 12.9%;
					}
					.entity-content-main {
						width: 52.5%;
					}
				}
			}
			&.entity-content-level-2 {
				padding-left: var(--px-20);
				.entity-content-main {
					width: calc(100% - var(--px-480)) !important;
					cursor: default;
					padding-right: var(--px-15);
					@media only screen and (max-width: 1280px) {
						width: calc(100% - var(--px-250)) !important;
					}
					&.controlEntityContentWrapper {
						width: 54.5% !important;
						@media only screen and (max-width: 1280px) {
							width: 54.3% !important;
						}
					}
				}
				.motif-tree-content {
					max-height: unset;
				}
			}
			&.entity-content-level-3 {
				padding-left: var(--px-20);
				.motif-tree-content {
					max-height: unset;
				}
			}
			&.entity-content-level-4 {
				padding-left: var(--px-20);
				.motif-tree-content {
					max-height: unset;
				}
			}
			button {
				svg {
					margin-top: var(--px-5);
				}
			}
			.entity-content-main {
				max-width: calc(100% - var(--px-50)) !important;
				font-size: var(--px-14);
				color: var(--blue-600);
				display: inline-flex;
				font-weight: 300;
				line-height: normal;
				overflow: hidden;
				.RelatedObjectTextWrapper {
					max-width: calc(100% - var(--px-40));
					width: calc(100% - var(--px-40)) !important;
					font-size: var(--px-14);
					color: var(--blue-600);
					font-weight: 100;
					min-height: var(--px-20);
					display: inline-flex;
					align-items: center;
					line-height: var(--px-20);
					&:hover {
						text-decoration: underline;
						cursor: pointer;
					}
				}
				.ellipses-multilines {
					&:hover {
						text-decoration: underline;
						cursor: pointer;
					}
				}
				.CountWrapper {
					background: var(--neutrals-900);
					color: var(--neutrals-00white);
					padding: var(--px-2) var(--px-10);
					margin-left: var(--px-10);
					font-size: var(--px-12);
					border-radius: var(--px-10);
					height: var(--px-20);
					display: inline-flex;
					line-height: normal;
				}
			}
			.entity-content-data {
				width: 15%;
				cursor: default;
				display: inline-flex;
				padding: 0 var(--px-10) 0 0;
				align-items: flex-start;
				&.ThirdCol {
					&.effectiveness-not-selected {
						color: var(--neutrals-700);
					}
					&.effectiveness-ineffective {
						color: var(--red-600);
					}
				}
				&.FourthCol {
					justify-content: center;
					margin-left: auto;
				}
				&.RelatedCanvasFormIcon {
					justify-content: center;
					width: 16%;
					padding-right: 0;
				}
			}
		}
		.CountWrapper {
			background: var(--neutrals-900);
			color: var(--neutrals-00white);
			padding: var(--px-2) var(--px-10);
			font-size: var(--px-12);
			border-radius: var(--px-10);
			height: var(--px-20);
			display: inline-flex;
			line-height: normal;
		}
		&.sectionObjectRisk {
			.entity-content-main {
				width: calc(100% - var(--px-180)) !important;
				max-width: calc(100% - var(--px-50)) !important;
				.RiskRelatedIcon {
					display: inline-block;
					cursor: default;
					width: var(--px-40);
					.motif-icon {
						display: inline-flex;
					}
					svg {
						margin-top: var(--px-3);
						cursor: default;
						fill: var(--neutrals-900);
					}
					.RiskRelatedIconText {
						position: relative;
						top: calc(var(--px-1) * -1);
						font-size: var(--px-12);
					}
				}
			}
		}
	}
`;

export default SectionRelatedObjectItem;
